import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import templateUrl from "emun.cart/snappay/cart-creditcard-snappay.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import cartConfig from "emun.cart/cart.config";

export class CartCreditCardSnappayController extends Shared {
	constructor($cart, $scope, $sce, $rootScope) {
		super($cart, $scope, $sce);
		let $stateParams = resolve("$stateParams");
		if ($stateParams.cartId) $cart.load($stateParams.cartId);
		let $ctrl = this;
		$ctrl.bus = new ServiceBus;
		$ctrl.cartConfig = cartConfig;
		let retailerId = $ctrl.retailerId || $ctrl.$cart.retailerId;
		let returnUri = $ctrl.returnUri;
		$ctrl.bus.send("SnapPay/GetRequestId.json", {CartId: $cart.id}).then(function(res) {
			console.debug("BL*** res", res);
			if (res.data) {
				$ctrl.requestId = res.data.requestid;
				var url = $ctrl.cartConfig.snapPayPage + "?reqno=" + $ctrl.requestId;
				$ctrl.snapPayPage = $sce.trustAsResourceUrl(url);
				window.location = $ctrl.snapPayPage;
			}
		});
		window.addEventListener('message', $ctrl.cardEntered, false);
	}
	cardEntered(e) {
		const $ctrl = this;
		let $rootScope = resolve("$rootScope");
		if (e.data != null && e.data != 'undefined') {
			//handle wallet response
			const obj = JSON.parse(e.data);
			if (obj != null) {
				if (obj.Event == 'OnWalletUpdateCompleted') {
					var result = obj.Result;
					if (result != null && result === true) {
						var CardID = obj.ID;
					}
				} else if (obj.Event == 'OnWalletCreateCompleted') {
					var CardID = obj.ID;
					if (CardID != null) {
						$rootScope.$broadcast("creditCardCreated", obj);
					}
				}
				// else if (obj.Event == 'OnTransactionCompleted' || obj.Event == 'successCallback') {
				// 	var trxkey = obj.TrxKey;
				// 	if (trxkey != null && trxkey != '') {
				// 		var RespStatus = obj.RespStatus;
				// 		var mgs = "trxkey: " + trxkey + " ,RespStatus:" + RespStatus + "ResultCode:" + obj.ResultCode + "TrxDate:" + obj.TrxDate + "TrxDateUTC:" + obj.TrxDateUTC + "RespTrxTag:" + obj.RespTrxTag;
				// 		console.debug("BL*** card results", mgs);
				// 	}
				// }
			}
		}
   }
}

export default {
	bindings: {
		retailerId: "@",
		returnUri: "@"
	},
	controller: CartCreditCardSnappayController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
